import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormInput } from 'shared/components'

const AthleteFiltersComponent = ({ form }) => (
  <Form form={form}>
    <FormInput name="search" icon="search" placeholder="Search..." />
  </Form>
)

AthleteFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
}

export default AthleteFiltersComponent
